<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.back()"
            :disabled="submittingForm"
          >
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Documento
        </h1>
      </v-col>
    </v-row>

    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="6">
            <e-label>Componente Curricular</e-label>
            <ValidationProvider name="Componente Curricular" rules="required" v-slot="{ errors }">
              <e-autocomplete
                :items="disciplinasList"
                v-model="form.disciplina_id"
                item-value="id"
                item-text="descricao"
                label="Selecione um Componente Curricular"
                solo
                dense
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>

          <v-col cols="6">
            <e-label>Etapa</e-label>
            <ValidationProvider name="Etapa" rules="required" v-slot="{ errors }">
              <v-select
                :items="etapasList"
                :item-text="(etapa) => `${etapa.descricao} - ${etapa.circuito.descricao}`"
                item-value="id"
                v-model="form.etapa_id"
                label="Selecione uma etapa"
                solo
                dense
                :error-messages="errors"
                no-data-text="Nenhuma etapa 'entrada' no circuito atual"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Etapas" rules="required" v-slot="{ errors }">
              <e-autocomplete
                :items="seriesList"
                v-model="form.series"
                multiple
                item-value="id"
                item-text="descricao"
                label="Selecione as etapas"
                solo
                dense
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <e-label>Arquivo PDF</e-label>
            <v-file-input
              v-model="form.pdf"
              accept=".pdf"
              label="Selecione o PDF"
              outlined
              dense
              :required="!editing"
            />
            <div v-if="editing && form.filename && !form.pdf">
              Arquivo atual:
              <v-btn x-small @click="baixarPdf(documentoId)" class="ml-2" color="red lighten-5">
                <span class="mr-2">{{ form.filename }}</span>
                <v-icon color="red lighten-1" small> fa fa-file-pdf</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <div class="d-flex">
              <v-btn
                color="primary"
                :disabled="submittingForm"
                :loading="submittingForm"
                type="submit"
              >
                Enviar Dados
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import { mapActions } from "vuex";
import ELabel from "@/components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: Boolean,
    documentoId: Number,
  },
  data() {
    return {
      submittingForm: false,
      form: {
        pdf: null, // Arquivo selecionado
        disciplina_id: null,
        etapa_id: null,
        series: [], // Array de IDs
        filename: null,
      },
      seriesList: [],
      disciplinasList: [],
      etapasList: [],
    };
  },
  mounted() {
    this.loadData();
    if (this.editing) {
      this.loadDocumento();
    }
  },
  methods: {
    async loadData() {
      this.seriesList = await this.$services.seriesService.syncAll();
      this.disciplinasList = await this.$services.disciplinasService.syncAll();
      this.etapasList = await this.$services.etapasService.getEtapasEntrada();
    },

    async loadDocumento() {
      const documento = await this.$services.documentosPlanosService.buscarPorId(
        parseInt(this.documentoId, 10)
      );
      if (documento) {
        this.form = {
          disciplina_id: documento.disciplina_id,
          etapa_id: documento.etapa_id,
          series: documento.series.map((s) => s.id),
          pdf: null,
          filename: documento.filename,
        };
      }
    },

    onFileChange(e) {
      this.form.caminho_pdf = e.target.files[0];
    },
    async submitForm() {
      this.submittingForm = true;

      const isUpdatingFile = this.form.pdf instanceof File;

      if (!this.editing || isUpdatingFile) {
        if (!this.form.pdf) {
          this.$toast.error("Selecione um arquivo PDF.");
          this.submittingForm = false;
          return;
        }

        const MAX_FILE_SIZE_MB = 2;
        const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
        if (this.form.pdf.size > MAX_FILE_SIZE_BYTES) {
          this.$handleError(new Error(`O arquivo não pode ser maior que ${MAX_FILE_SIZE_MB}MB`));
          this.submittingForm = false;
          return;
        }
      }

      const formData = new FormData();

      if (isUpdatingFile) {
        formData.append("file", this.form.pdf);
      }

      formData.append("disciplina_id", this.form.disciplina_id);
      formData.append("etapa_id", this.form.etapa_id);

      this.form.series.forEach((id) => {
        formData.append("series[]", id);
      });
      try {
        if (this.editing) {
          await this.$services.documentosPlanosService.atualizar(this.documentoId, formData);
          this.$toast.success("Documento atualizado com sucesso");
        } else {
          await this.$services.documentosPlanosService.salvar(formData);
          this.$toast.success("Documento criado com sucesso");
        }
        this.$router.push({ name: "gerenciarPlanos" });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.submittingForm = false;
      }
    },
    async baixarPdf(matricula_id) {
      this.$loaderService.open("Baixando...");
      try {
        await this.$services.documentosPlanosService.baixarPdf(parseInt(this.documentoId, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style scoped></style>
